<template>
  <v-container fluid class="homepage-bg d-flex justify-center align-center pa-0"
    style="min-height: 90vh; padding: 0 !important;">
    <v-card max-width="90%" class="pa-7 text-center rounded-2xl elevation-3 homepage-card">
      <img src="/img//logo.png" alt="Logo" class="mb-3" style="width:60px; height:auto; object-fit:contain;"/>

      <div class="mb-6" style="color:#5b6470;font-size:1.1rem;">
        {{ this.$t('homePage.subtitle') }}
      </div>

      <!-- KARTICE -->
      <v-row class="ma-0 pa-0" justify="center">
        <v-col cols="12" sm="4" v-for="card in cardsTop" :key="card.title" class="d-flex justify-center">
          <v-card class="hoverable-card card-fit" outlined @click="go(card.route)" style="overflow: hidden;">
            <img :src="cardImages[card.key]" class="card-img" />
          </v-card>
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-col cols="12" sm="4" v-for="card in cardsBottom" :key="card.title" class="d-flex justify-center">
          <v-card class="hoverable-card card-fit" outlined @click="go(card.route)" style="overflow: hidden;">
            <img :src="cardImages[card.key]" class="card-img" />
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      cardsTop: [
        { key: 'home1', title: this.$t('homePage.card1.title'), desc: this.$t('homePage.card1.subtitle'), route: "/asset" },
        { key: 'home2', title: this.$t('homePage.card2.title'), desc: this.$t('homePage.card2.subtitle'), route: "/smallAsset" },
        { key: 'home3', title: this.$t('homePage.card3.title'), desc: this.$t('homePage.card3.subtitle'), route: "/komisije" },
      ],
      cardsBottom: [
        { key: 'home4', title: this.$t('homePage.card4.title'), desc: this.$t('homePage.card4.subtitle'), route: "/maintenance" },
        { key: 'home5', title: this.$t('homePage.card5.title'), desc: this.$t('homePage.card5.subtitle'), route: "/software" },
        { key: 'home6', title: this.$t('homePage.card6.title'), desc: this.$t('homePage.card6.subtitle'), route: "/popis" },
      ],
    }
  },
computed: {
currentLang() {
  const lang = localStorage.getItem('lang')
  if (lang === 'sr' || lang === 'cir-ekavica') return '_cir'
  if (lang === 'en') return '_eng'
  return ''
},
  cardImages() {
    const lang = this.currentLang
    return {
      home1: `/img/Home1${lang}.png`,
      home2: `/img/Home2${lang}.png`,
      home3: `/img/Home3${lang}.png`,
      home4: `/img/Home4${lang}.png`,
      home5: `/img/Home5${lang}.png`,
      home6: `/img/Home6${lang}.png`,
    }
  }
},
  methods: {
    go(route) {
      this.$router.push(route);
    }
  }
}
</script>

<style scoped>
.hoverable-card {
  transition: box-shadow 0.22s, transform 0.14s;
  cursor: pointer;
  min-height: unset;
  height: 180px;
  border-radius: 10px;
}

.homepage-bg {
  min-height: 100vh;
  background: linear-gradient(to bottom, #f5f8fc 60%, #e3eaf6 100%);
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.homepage-card {
  border-radius: 22px;
  box-shadow: 0 6px 32px 0 rgba(20, 55, 110, 0.07);
  margin-top: 20px;
  margin-bottom: 20px;
}

.hoverable-card {
  transition: box-shadow 0.22s, transform 0.14s;
  cursor: pointer;
}

.hoverable-card:hover {
  box-shadow: 0 3px 18px 0 #3a86ff24;
  transform: translateY(-3px) scale(1.02);
}

.card-img {
  width: 250px;
  /* promijeni po želji (160–220px idealno) */
  object-fit: contain;
  display: block;
}
</style>
